"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalForm = void 0;
const Field_type_1 = require("../../../types/Field.type");
const LegalForm_1 = require("../../enm/LegalForm");
exports.LegalForm = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.legal_form.label',
    fallbackLabel: 'Legal entity Type',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: LegalForm_1.LegalFormRef.options,
    mfValidation: {
        pathToValidation: 'business/legalForm',
    },
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MANAGED_MERCHANT_IN_STORE' || payload.contract_onboarding_type?.valueOf?.() === 'KLARNA_POINT_OF_SALES');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MANAGED_MERCHANT_IN_STORE' || payload.contract_onboarding_type?.valueOf?.() === 'KLARNA_POINT_OF_SALES');
}
